import { Toolbar } from 'primereact/toolbar';
import MonitoringNavBlock from '../components/NavBlocks/MonitoringNavBlock';

const Monitoring = () => {
  return (
    <div className="grid nc_content-frame nc_page-inner">
      <Toolbar role="section" className="col-10 col-offset-1 nc_page-header" center={<h1>Monitoring</h1>} />
      <div className="col-10 col-offset-1 flex flex-column align-items-center">
        <div className="nc_block">
          <MonitoringNavBlock></MonitoringNavBlock>
        </div>
      </div>
    </div>
  );
};

export default Monitoring;
